import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function DeviceGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default DeviceGenericSkeleton;
